module.exports = __webpack_public_path__ + "img/minus.7297bdc7.jpg";